const calendarResourceOptions: Record<CalendarResources, CalendarResourceOptions> = {
    'roommanagement': {
        moduleName: 'Raumverwaltung',
        moduleColor: '#ac232a',
        linkedCalendarsAllowed: true,
        groupsAllowed: true,
        entryHasCalendarSelect: true,
        hasContact: true,
        hasClient: true,
        hasExport: true,
        draftAllDayRow: false,
        canMultipleBooking: true,
        hasBookingInTimeOnlyToggle: true,
        calendarType: 'Raum',
        calendarAssociation: 'Raum',
        calendarTypePlural: 'Räume',
        calendarIcon: 'pin_drop',
        calendarIconAdd: 'add_location',
        calendarArticle: 'der',
        entryType: 'Reservierung',
        entryTypeGenus: 'feminine',
        entryTypeGenitive: 'Reservierung',
        entryTypePlural: 'Reservierungen',
        entryTypeMail: 'Raumreservierung',
        entryRequest: 'Reservierungsanfrage',
        entryRequestPlural: 'Reservierungsanfragen',
    },
    'vehicle': {
        moduleName: 'Fahrzeuge',
        moduleColor: '#ba2e35',
        linkedCalendarsAllowed: true,
        groupsAllowed: true,
        entryHasCalendarSelect: true,
        hasContact: true,
        hasClient: true,
        hasExport: true,
        draftAllDayRow: false,
        canMultipleBooking: false,
        hasBookingInTimeOnlyToggle: false,
        calendarType: 'Fahrzeug',
        calendarAssociation: 'Fahrzeug',
        calendarTypePlural: 'Fahrzeuge',
        calendarIcon: 'drive_eta',
        calendarIconAdd: 'drive_eta',
        calendarArticle: 'das',
        entryType: 'Reservierung',
        entryTypeGenus: 'feminine',
        entryTypeGenitive: 'Reservierung',
        entryTypePlural: 'Reservierungen',
        entryTypeMail: 'Raumreservierung',
        entryRequest: 'Reservierungsanfrage',
        entryRequestPlural: 'Reservierungsanfragen',
    },
    'sportsarea': {
        moduleName: 'Sportstätten',
        moduleColor: '#d63d40',
        linkedCalendarsAllowed: true,
        groupsAllowed: true,
        entryHasCalendarSelect: true,
        hasContact: true,
        hasClient: true,
        hasExport: true,
        draftAllDayRow: false,
        canMultipleBooking: true,
        hasBookingInTimeOnlyToggle: true,
        calendarType: 'Sportstätte',
        calendarAssociation:'Sportstätten',
        calendarTypePlural: 'Sportstätten',
        calendarIcon: 'fitness_center',
        calendarIconAdd: 'fitness_center',
        calendarArticle: 'die',
        entryType: 'Reservierung',
        entryTypeGenus: 'feminine',
        entryTypeGenitive: 'Reservierung',
        entryTypePlural: 'Reservierungen',
        entryTypeMail: 'Raumreservierung',
        entryRequest: 'Reservierungsanfrage',
        entryRequestPlural: 'Reservierungsanfragen',
    },
    'equipment': {
        moduleName: 'Geräte',
        moduleColor: '#c6353b',
        linkedCalendarsAllowed: true,
        groupsAllowed: true,
        entryHasCalendarSelect: true,
        hasContact: true,
        hasClient: true,
        hasExport: true,
        canMultipleBooking: false,
        hasBookingInTimeOnlyToggle: false,
        draftAllDayRow: false,
        calendarType: 'Gerät',
        calendarAssociation: 'Geräte',
        calendarTypePlural: 'Geräte',
        calendarIcon: 'devices',
        calendarIconAdd: 'devices',
        calendarArticle: 'das',
        entryType: 'Reservierung',
        entryTypeGenus: 'feminine',
        entryTypeGenitive: 'Reservierung',
        entryTypePlural: 'Reservierungen',
        entryTypeMail: 'Raumreservierung',
        entryRequest: 'Reservierungsanfrage',
        entryRequestPlural: 'Reservierungsanfragen',
    },
    'appointment': {
        moduleName: 'Termine',
        moduleColor: '#bf3810',
        linkedCalendarsAllowed: false,
        groupsAllowed: false,
        entryHasCalendarSelect: false,
        hasContact: false,
        hasClient: false,
        hasExport: false,
        canMultipleBooking: true,
        hasBookingInTimeOnlyToggle: false,
        draftAllDayRow: true,
        calendarType: 'Kalender',
        calendarTypePlural: 'Kalender',
        calendarIcon: 'date_range',
        calendarIconAdd: 'date_range',
        calendarArticle: 'der',
        entryType: 'Termin',
        entryTypeGenus: 'masculine',
        entryTypeGenitive: 'Termin',
        entryTypePlural: 'Termin',
        entryTypeMail: 'Termin',
        entryRequest: 'Anfrage',
        entryRequestPlural: 'Anfragen',
    },
    'event': {
        moduleName: 'Veranstaltungen',
        moduleColor: '#bf3810',
        linkedCalendarsAllowed: false,
        groupsAllowed: false,
        entryHasCalendarSelect: false,
        hasContact: false,
        hasClient: true,
        hasExport: false,
        canMultipleBooking: true,
        hasBookingInTimeOnlyToggle: false,
        draftAllDayRow: true,
        calendarType: 'Kalender',
        calendarTypePlural: 'Kalender',
        calendarIcon: 'event',
        calendarIconAdd: 'date_range',
        calendarArticle: 'der',
        entryType: 'interne Veranstaltung',
        entryTypeGenus: 'feminine',
        entryTypeGenitive: 'Veranstaltung',
        entryTypePlural: 'Veranstaltung',
        entryTypeMail: 'Veranstaltung',
        entryRequest: 'Anfrage',
        entryRequestPlural: 'Anfragen',
    },
    'services': {
        moduleName: 'Terminbuchung',
        moduleColor: '#ac232a',
        linkedCalendarsAllowed: false,
        groupsAllowed: false,
        entryHasCalendarSelect: true,
        hasContact: true,
        hasClient: false,
        hasExport: false,
        draftAllDayRow: false,
        canMultipleBooking: true,
        hasBookingInTimeOnlyToggle: true,
        calendarType: 'Kalender',
        calendarTypePlural: 'Kalender',
        calendarTypeGenus: 'masculine',
        calendarIcon: 'event',
        calendarIconAdd: 'event',
        calendarArticle: 'der',
        entryType: 'Termin',
        entryTypeGenus: 'masculine',
        entryTypeGenitive: 'Termin',
        entryTypePlural: 'Termine',
        entryTypeMail: 'Termin',
        entryRequest: 'Terminanfrage',
        entryRequestPlural: 'Terminanfragen',
    },
    'meetingservice': {
        moduleName: 'Sitzungsdienst',
        moduleColor: '#bf3810',
        linkedCalendarsAllowed: false,
        groupsAllowed: false,
        entryHasCalendarSelect: false,
        hasContact: false,
        hasClient: false,
        hasExport: false,
        canMultipleBooking: true,
        hasBookingInTimeOnlyToggle: false,
        draftAllDayRow: false,
        calendarType: 'Kalender',
        calendarTypePlural: 'Kalender',
        calendarIcon: 'date_range',
        calendarIconAdd: 'date_range',
        calendarArticle: 'der',
        entryType: 'Sitzung',
        entryTypeGenus: 'feminine',
        entryTypeGenitive: 'Sitzung',
        entryTypePlural: 'Sitzungen',
        entryTypeMail: 'Sitzungen',
        entryRequest: 'Anfrage',
        entryRequestPlural: 'Anfragen',
    },
    'councilservice': {
        moduleName: 'Ratsinformationssystem',
        moduleColor: '#bf3810',
        linkedCalendarsAllowed: false,
        groupsAllowed: false,
        entryHasCalendarSelect: false,
        hasContact: false,
        hasClient: false,
        hasExport: false,
        canMultipleBooking: true,
        hasBookingInTimeOnlyToggle: false,
        draftAllDayRow: false,
        calendarType: 'Kalender',
        calendarTypePlural: 'Kalender',
        calendarIcon: 'date_range',
        calendarIconAdd: 'date_range',
        calendarArticle: 'der',
        entryType: 'Sitzung',
        entryTypeGenus: 'feminine',
        entryTypeGenitive: 'Sitzung',
        entryTypePlural: 'Sitzungen',
        entryTypeMail: 'Sitzungen',
        entryRequest: 'Anfrage',
        entryRequestPlural: 'Anfragen',
    },
};

export {
    calendarResourceOptions,
};